import React, { useEffect } from "react"
import { HugoStateApi, expressions, useButton, useTemplateEngine } from "../hugo"
import { useNavigate } from "react-router-dom"
import { Cell, Icon, Paper, Row, Wall, arrow1Icon, mailIcon, xingIcon } from "../ui"
import contactImg from "./assets/contact.png"

type Props = {
    hugoApi: HugoStateApi
}

const Imprint: React.FC<Props> = ({ hugoApi }) => {
    const render = useTemplateEngine();
    useEffect(() => {
        setTimeout(() => { hugoApi.output(render(expressions.legal), { append: false }) }, 100)
    }, [])

    return (
        <Wall>
            <Paper $rotate={3}>
                <Row $height={1.8} $skewStrength={0.1}>
                    <Cell $width={1.5}>
                        <h1>Impressum</h1>
                        
                        <p>Alexander M&uuml;hrenberg</p>

                        <h2>Kontakt</h2>
                        <p>
                            Telefon:<br /> 015756692788<br />
                            E-Mail:<br />alexander@muehrenberg.de<br />
                        </p>
                    </Cell>
                </Row>
            </Paper>
        </Wall>
    )
}

export default Imprint